<template>
  <div>
    <!-- <div>收费记录</div> -->

    <el-form
      :model="searchForm"
      label-width="90px"
      size="small"
    >
      <el-row>
        <el-col span="6">
          <el-form-item label="收费科目">
            <el-select
              style="width: 100%"
              multiple
              :disabled="subjectDisabledFlag"
              v-model="subjectIds"
              @change="subjectIdChange"
            >
              <el-option
                v-for="item in subjectList"
                :key="item"
                :value="item.dictKey"
                :label="item.dictValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="6">
          <el-form-item label="支付日期">
            <el-date-picker
              style="width: 100%"
              v-model="payTimeRange"
              type="daterange"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col span="6">
          <el-form-item label="支付方式">
            <el-select style="width: 100%" 
            clearable
            v-model="payType"
            >
              <el-option
                v-for="item in payTypeList"
                :key="item"
                :value="item.dictKey"
                :label="item.dictValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="6">
          <el-form-item label-width="10px">
            <div style="width: 100%;text-align: right;">
            <el-button type="primary" @click="onSearchHandler">搜索</el-button>
            <el-button type="default" @click="onClearHandler">清空</el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>


    <el-table
    v-loading="showLoadingFlag"
    :data="payBillList"
    height="450"
    border
    style="width: 100%">
    <el-table-column
        label="序号"
      type="index"
      width="50">
    </el-table-column>
      <el-table-column
        prop="feeSortName"
        label="费用类别"
        width="180">
      </el-table-column>
      <el-table-column
        prop="billcycleNo"
        label="账单周期"
        width="100">
      </el-table-column>
      <el-table-column
        prop="billcycleNoStart"
        label="开始日期"
        width="180">
      </el-table-column>
      <el-table-column
        prop="billcycleNoEnd"
        label="结束日期"
        width="180">
      </el-table-column>
      <el-table-column
        prop="shouldAmount"
        label="应收金额"
        width="100">
      </el-table-column>
      <el-table-column
        prop="discountAmount"
        label="优惠金额"
        width="100">
      </el-table-column>
      <el-table-column
        prop="payAmount"
        label="实收金额"
        width="100">
      </el-table-column>
      <el-table-column
        prop="payStatusName"
        label="状态"
        width="100">
      </el-table-column>
      <el-table-column
        prop="payTypeName"
        label="支付方式"
        width="100">
      </el-table-column>
      <el-table-column
        prop="payTime"
        label="支付时间"
        width="180">
      </el-table-column>
      <el-table-column
        prop="cashierName"
        label="收费人"
        width="100">
      </el-table-column>
    </el-table>
    <div style="text-align:right;margin-top:1rem;" v-if="totalPage>0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="sizePage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalPage">
      </el-pagination>
    </div>
  </div>
</template>

  <script>
import { getDict, getPayBillList, getPayTypeList } from '@/api/charge/charge-pay';
import dayjs from 'dayjs';
export default {
  props: ['targetId'],
  data() {
    return {
      showLoadingFlag:false,
      totalPage:0,
      currentPage:1,
      sizePage:10,
      subjectDisabledFlag: false,
      search: {},
      payType: '',
      payTimeRange: '',
      subjectList: [],
      searchForm: {},
      subjectIds: [],
      payBillList: [],
      payTypeList: [],
      searchHistoryFromOption: {
        menuBtn: false,
        column: [
          {
            label: '收费科目',
            prop: 'feeItems',
            type: 'select',
            formslot: true,
            span: 6,
            maxlength: 3,
          },
          {
            label: '支付日期',
            prop: 'payTimeRange',
            type: 'select',
            formslot: true,
            span: 6,
            maxlength: 3,
          },
          {
            label: '支付方式',
            prop: 'payType',
            type: 'select',
            formslot: true,
            span: 6,
            maxlength: 3,
          },
        ],
      },
    };
  },
  mounted() {
    this.getSubjectListHandler();
    this.getPayTypeListHandler();
  },
  methods: {
    onClearHandler(){
      this.sizePage = 10;
      this.currentPage = 1;
      this.payTimeRange = [];
      this.payTimeStart = '';
      this.payTimeEnd = '';
      this.payType = '';
      this.subjectIds = ['99'];
      this.subjectIdChange();

    },
    onSearchHandler(){
      this.currentPage = 1;
      this.getPayBillListHandler();
    },
    handleSizeChange(val) {
this.sizePage = val;
        console.log(`每页 ${val} 条`);
        this.getPayBillListHandler();
      },
      handleCurrentChange(val) {
this.currentPage = val;
        console.log(`当前页: ${val}`);
        this.getPayBillListHandler();
      },
    subjectIdChange(val) {
      console.log(val);
      if (!val || val.length < 1) {
        val = ['99'];
      }
      let self = this;
      if (val && val.length > 1) {
        console.log('subjectIdChange=====>', val);
        val.forEach((ele, index) => {
          if (ele === '99') {
            self.subjectIds.splice(index, 1);
          }
        });
      }
      // this.pageOption.current = 1;
      this.getPayBillListHandler(this.targetId, true, val);
      console.log('subjectIdChange=========>', val);
    },
    transferTimeRange(){
      if(this.payTimeRange.length>0){
      this.payTimeStart = this.payTimeRange[0]+' 00:00:00'
      this.payTimeEnd = this.payTimeRange[1]+' 23:59:59'
      }else{
      this.payTimeStart = ''
      this.payTimeEnd = ''
      }
    },
    getPayBillListHandler(id, flag, feeItems) {
      if(!this.targetId){
        this.$message.error('请选择房间号！');
        return;
      }
      if(flag){
        this.currentPage = 1;
      }
      this.transferTimeRange();
      let this_ = this;
      let subjectIds_ = feeItems?feeItems.join(','):this.subjectIds.join(',');
      console.log("this.subjectIds===========>",this.subjectIds);
      this.showLoadingFlag = true;
      getPayBillList({ payType: this_.payType,payTimeStart:this_.payTimeStart, payTimeEnd:this_.payTimeEnd, roomId: this_.targetId, feeItems: subjectIds_ , size:this_.sizePage, current:this.currentPage}).then((res) => {
        res.data.records.forEach((ele)=>{
          ele.billcycleNoStart = dayjs(ele.billcycleNoStart).format('YYYY-MM-DD')
          ele.billcycleNoEnd = dayjs(ele.billcycleNoEnd).format('YYYY-MM-DD')
        })
        this.payBillList = res.data.records;
        
        console.log('getPayBillListHandler==========>', res.data);
        
                    this.totalPage = res.data.total;
                    // this.currentPage = currentPage;
                    // this.
      this.showLoadingFlag = false; 
      }).catch((e)=>{
        console.log(e);
      this.showLoadingFlag = false; 
      });
    },
    getPayTypeListHandler() {
      getPayTypeList().then((res) => {
        this.payTypeList = res.data;
      });
    },
    getSubjectListHandler() {
      // getSubjectList().then((res)=>{
      getDict({ code: 'fee_item_type' }).then((res) => {
        console.log(res);
        this.subjectList = res.data;
        // this.subjectList.unshift({id:'',name:'全部'});
        console.log(this.subjectList);
        this.subjectIds = [this.subjectList[3].dictKey];
      });
    },
  },
};
</script>

<style scoped>
  .demo-form-inline .el-form-item__content{
    width: 100%;
  }
</style>